import React from 'react'
import PropTypes from 'prop-types'
import { InWinImage } from 'routes/shared/components'

import * as styles from './styles'

const CountryCellComponent = ({ value: event }) =>
  event.jurisdiction ? (
    <InWinImage
      source={event.jurisdiction.logo}
      alt={event.jurisdiction.name}
      css={styles.logo}
    />
  ) : (
    event.country
  )

CountryCellComponent.propTypes = {
  value: PropTypes.shape(),
}

export default CountryCellComponent
